import Vue from 'vue'
import Router from 'vue-router'


import Main from '@/components/main.vue'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main,
      redirect: '/home',
      children: [
        {
          path: '/home',
          name: 'home',
          // meta: {
          //   keepAlive: true
          // },
          component: resolve => require(['@/components/home'], resolve),
          },
          {
              path: '/reset',
              name: 'reset',
              component: resolve => require(['@/components/reset'], resolve),
          },
        {
          path: '/login',
          name: 'login',
          // meta: {
          //   keepAlive: true
          // },
          component: resolve => require(['@/components/login'], resolve),
        },
        {
          path: '/index',
          name: 'index',
          // meta: {
          //   keepAlive: true
          // },
          component: resolve => require(['@/components/index'], resolve),
        }
      ]
      // meta: {
      //   keepAlive: true
      // },
      // component: resolve => require(['@/components/index'], resolve),
    },
    {
      path: '/hello',
      name: 'hello',
      // meta: {
      //   keepAlive: true
      // },
      component: resolve => require(['@/components/HelloWorld'], resolve),
    },
    {
        path: '/test',
        name: 'test',
        component: resolve => require(['@/components/test'], resolve),
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js